import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../../styles/LoginPage.css";

function RoseArtwork() {
  return <svg className="sh-login-art" viewBox="0 0 440 440" fill="none" aria-hidden="true">
    <circle cx="220" cy="215" r="173" stroke="#ffffff" strokeOpacity=".16" />
    <circle cx="220" cy="215" r="135" stroke="#ffffff" strokeOpacity=".1" />
    <path d="M219 366V204" stroke="#d9de91" strokeWidth="5" strokeLinecap="round" />
    <path d="M218 311C159 310 126 279 122 244C179 244 212 267 218 311Z" fill="#a9ae50" />
    <path d="M221 275C272 275 309 246 315 212C260 212 226 240 221 275Z" fill="#d2d88a" />
    <path d="m139 261 76 47m21-48 62-36" stroke="#536134" strokeWidth="1.5" />
    <g transform="translate(220 157)">
      {[0,60,120,180,240,300].map((angle) => <ellipse key={angle} cx="0" cy="-39" rx="43" ry="64" transform={`rotate(${angle})`} fill="#edb5ce" stroke="#a92f6f" strokeWidth="1.5" />)}
      {[30,150,270].map((angle) => <ellipse key={angle} cx="0" cy="-17" rx="29" ry="42" transform={`rotate(${angle})`} fill="#f8d6e5" stroke="#a92f6f" strokeWidth="1.5" />)}
      <path d="M-17 10C-33-18 9-37 24-12C34 9 0 27-8 6C-12-6 7-15 13-3" stroke="#a92f6f" strokeWidth="3" strokeLinecap="round" />
    </g>
    <path d="M67 160h18m-9-9v18M346 300h14m-7-7v14" stroke="#d9de91" strokeWidth="2" />
    <circle cx="341" cy="97" r="4" fill="#d9de91" />
  </svg>;
}

export default function LoginPage() {
  const { handleLogin } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
    setError("");
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    setError("");
    setLoading(true);
    try {
      const user = await handleLogin(formData.username.trim(), formData.password);
      navigate(user?.role === "customer" ? (user.must_change_password ? "/clients/password" : "/clients") : "/capture");
    } catch {
      setError("Unable to sign in. Check your username and password, then try again.");
    } finally {
      setLoading(false);
    }
  };
  return <main className="sh-login">
    <div className="sh-login-shell">
      <section className="sh-login-story" aria-label="SmartHarvest">
        <div className="sh-login-brand"><span className="sh-login-mark" aria-hidden="true">sh<span>↗</span></span><span>SmartHarvest<small>FIELD TO PACKHOUSE</small></span></div>
        <div className="sh-login-editorial"><p className="sh-login-kicker">GROWN WITH CARE. CAPTURED WITH PURPOSE.</p><h1>Every stem. <br />Every hand. <br /><em>Every harvest.</em></h1><p>A connected workspace for the people<br className="sh-login-desktop-break" /> behind every harvest.</p></div>
        <RoseArtwork />
        <div className="sh-login-story-footer"><span>From the field, forward.</span><span aria-hidden="true">01 — ∞</span></div>
      </section>
      <section className="sh-login-access" aria-labelledby="sh-login-title">
        <div className="sh-login-topnote"><span className="sh-login-dot" /> YOUR DAILY WORKSPACE</div>
        <div className="sh-login-form-wrap">
          <span className="sh-login-welcome-icon" aria-hidden="true">↗</span>
          <p className="sh-login-kicker">WELCOME TO SMARTHARVEST</p>
          <h2 id="sh-login-title">Good to have <br />you back.</h2>
          <p className="sh-login-intro">Sign in and pick up where your team left off. Customer contacts use their own email and password.</p>
          <form onSubmit={handleSubmit} aria-busy={loading}>
            <label htmlFor="sh-username">Username or client email</label>
            <input id="sh-username" name="username" type="text" value={formData.username} onChange={handleChange} placeholder="Enter username or email" autoComplete="username" autoCapitalize="none" spellCheck={false} required disabled={loading} />
            <label htmlFor="sh-password">Password</label>
            <div className="sh-login-password"><input id="sh-password" name="password" type={showPassword ? "text" : "password"} value={formData.password} onChange={handleChange} placeholder="Enter your password" autoComplete="current-password" required disabled={loading} /><button type="button" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword}>{showPassword ? "Hide" : "Show"}</button></div>
            {error && <p className="sh-login-error" role="alert">{error}</p>}
            <button className="sh-login-submit" type="submit" disabled={loading}><span>{loading ? "Signing you in…" : "Sign in"}</span>{loading ? <span className="sh-login-spinner" aria-hidden="true" /> : <span aria-hidden="true">↗</span>}</button>
          </form>
          <p className="sh-login-help">Need access? <span>Contact your administrator.</span></p><a className="sh-login-reset-link" href="/password-reset">Forgot your password?</a>
        </div>
        <footer className="sh-login-footer"><span>© {new Date().getFullYear()} SmartHarvest</span><span>Rooted in teamwork.</span></footer>
      </section>
    </div>
  </main>;
}
